module.exports = "<div class=\"panel popin\">\n  <div class=\"panel-heading\">\n    <div class=\"title\">{{titre}}</div>\n  </div>\n  <div class=\"panel-body\">\n    <div class=\"\" style=\"margin:15px 0 15px 0\">{{message}}</div>\n    <button class=\"btn\" style=\"float: right\" (click)=\"acceptRemoteFunction()\">Accepter</button>\n    <button class=\"btn\" style=\"float: left\" (click)=\"deniedRemoteFunction()\">Refuser</button>\n  </div>\n</div>\n<div class=\"layer\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/photo/popin-photo/popin-photo.component.html
// module id = ./src/app/photo/popin-photo/popin-photo.component.html
// module chunks = main